import { InterviewResult } from '@core/interview-results-types';
import { Placement } from '@core/placements-types';

export interface RatingStats {
  evalCount: number;
  interviewerCount: number;
}

export const getInterviewResultsForPlacement = (
  placement: Placement,
  interviewResults: Record<number, InterviewResult[]>,
) =>
  Object.entries(interviewResults)
    .map(entry => {
      const [interviewerId, results] = entry;
      const currentPlacementResults = results.filter(
        result =>
          result.offerId === placement.offerId && ['rating', 'template_form'].includes(result.kind),
      );
      return <const>[interviewerId, currentPlacementResults];
    })
    .filter(([, results]) => results.length);

/**
 * Get the rating stats for a placement based on the interview results
 * @param placement
 * @param interviewResults
 */
export const getPlacementRatingStats = (
  placement: Placement,
  interviewResults: Record<number, InterviewResult[]>,
): RatingStats => {
  const ratingsForThisPlacement = getInterviewResultsForPlacement(placement, interviewResults);
  return {
    evalCount: ratingsForThisPlacement.reduce((acc, results) => acc + results[1].length, 0),
    interviewerCount: ratingsForThisPlacement.length,
  };
};
